module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_pp2_8023.3646dd80.png";